export class TicketToRidePlayerData {
	constructor(name, color) {
		this.guid = crypto.randomUUID();
		this.playerName = name;
		this.playerColor = color;
		this.routes = new Array(8).fill(0);
		this.bonuses = [];
	}

	static #routeValues = [1, 2, 4, 7, 10, 15, 18, 21];

	static getRouteScoreValue(routeIndex) {
		return this.#routeValues[routeIndex];
	}

	static getScore(data) {
		let sum = 0;
		for (let i = 0; i < data.routes.length && i < this.#routeValues.length; i++) {
			sum += data.routes[i] * this.#routeValues[i];
		}

		for (let i = 0; i < data.bonuses.length; i++) {
			sum += data.bonuses[i];
		}

		return sum;
	}

	static getTrainCount(data) {
		let sum = 0;
		for (let i = 0; i < data.routes.length && i < this.#routeValues.length; i++) {
			sum += data.routes[i] * (i + 1);
		}

		return sum;
	}
}